import { Text } from "@/components/Typography/Text";
import { defaultNS, useTranslation } from "@/lib/i18n";

export const DynamicSelectFieldErrorPresentation = () => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "features.formFactory.dynamicSelectField.error",
  });

  return (
    <div className="w-full p-3 border border-error-fill rounded-md bg-red-50">
      <Text variant="inputLabel" className="text-error-fill">
        {t("loading")}
      </Text>
    </div>
  );
};
